module.exports = __webpack_public_path__ + "static/city-of-whittlesea-logo-2393bdf62dd5d8548940d3bf7b79b67e.png";